import { ref as p, unref as i } from "vue";
import { logger as c } from "../../utils/logger.js";
import { requirejsOne as v } from "../require/require.js";
function w(s, o = "i18n!DS/SwymVueComponents/assets/nls/", a, u = !1) {
  const r = p({}), l = new Promise(async (t) => {
    try {
      const n = await v(`${o}${s}`);
      r.value = Object.assign(i(r), n);
    } catch {
      c.error(`Error loading nls ${o}${s}`);
    }
    if (a) {
      const { DS_LANG: n } = await import("../../config/global-var.js");
      try {
        const e = await a[`/assets/nls/${s}_en.json`]();
        n === "en" ? r.value = Object.assign(r.value, e) : r.value = { ...e, ...r.value };
      } catch (e) {
        r.value = {}, c.error(e);
      }
    }
    t(r.value);
  });
  function f(t, n = {}) {
    if (!t)
      return "";
    let e = i(r)[t];
    return Object.entries(n).forEach(([m, $]) => {
      e = e == null ? void 0 : e.replace(`{${m}}`, $);
    }), e || (u ? `__${t}__` : t);
  }
  return { i18n: r, $i18n: f, promise: l };
}
export {
  w as useTranslations
};
